import { MapCultureTo } from "../../../base-types";
import CultureInfo from "../../../culture-info";
import Guard from "../../../guard";
import { IOptionList, ITypedOptionList } from "./option-list";
import { OptionListType } from "./option-list-type";
import { IOptionListValue } from "./option-list-value";

export abstract class OptionListBase implements IOptionList {
    name: string;
    labels: MapCultureTo<string>;
    isSystemOwned: boolean;
    createdBy?: number;
    createdOn?: Date;
    modifiedBy?: number;
    modifiedOn?: Date;
    abstract type: OptionListType;

    constructor(name: string, labels?: MapCultureTo<string>) {
        Guard.stringNotNullOrEmpty(name);
        if (labels) {
            Guard.arrayNoneNullOrUndefined(Object.values(labels));
            Guard.arrayNoneNullOrInvariantCulture(Object.keys(labels) as Array<CultureInfo>);
        }

        this.name = name;
        this.labels = labels || {};
    }

    abstract getOptionListValues(): Array<IOptionListValue>;

    abstract setOptionListValues(values: Array<IOptionListValue>): void;
}

export abstract class TypedOptionListBase<T extends IOptionListValue = IOptionListValue>
    extends OptionListBase
    implements ITypedOptionList<T>
{
    values: Array<T>;

    constructor(name: string, labels?: MapCultureTo<string>, values?: Array<T>) {
        super(name, labels);

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        values && Guard.arrayNoneNullOrUndefined(values);
        this.values = values || [];
    }

    getOptionListValues(): Array<T> {
        return this.values;
    }

    setOptionListValues(values: Array<T>): void {
        this.values = values;
    }
}
